import { trackUserFreemiumLoginWallViewed, trackUserFreemiumLoginWallCtaClicked } from "../tracking/helpers";

/**
 * Update account button if user is logged
 * @param isLogged the meta data
 */

export const updateWalledElements = (isLogged) => {
  var mlsAccountLoading = document.querySelectorAll('.mls-account-wall-loading');
  var mlsAccountWall = document.querySelectorAll(".mls-account-wall");
  var mlsAccountWallContent = document.querySelectorAll('.mls-account-wall-content');
  var mlsAccountWallContentRight = document.querySelectorAll(".mls-account-wall-content--right ");
  var mlsLockVideoIcon = document.querySelectorAll(".-lock");

  if (mlsAccountLoading?.length) {
    mlsAccountLoading.forEach(function (element) {
      element.classList.remove("mls-account-wall-loading");
    });
  }

  if (isLogged) {

    if (mlsLockVideoIcon?.length) {
      mlsLockVideoIcon.forEach((el) => el.remove());
    }

    if (mlsAccountWall?.length) {
      mlsAccountWall.forEach(function (element) {
        element.remove();
      });
    }

    if (mlsAccountWallContent) {
      mlsAccountWallContent.forEach(function (element) {
        element.classList.remove("mls-account-wall-content");
      });
    }

    if (mlsAccountWallContentRight?.length) {
      mlsAccountWallContentRight.forEach(function (element) {
        element.classList.remove("mls-account-wall-content--right");
      });
    }

  } else {
    if (mlsAccountWallContent?.length) {
      var mlsAccountWallDivs = document.querySelectorAll('.mls-account-wall-content .body-part');
      var mlsAccountWallAds = document.querySelectorAll('.mls-account-wall-content .adv-part');
      var mlsAccountWallFooter = document.querySelectorAll('.mls-c-article__footer');

      if (mlsAccountWallDivs) {
        mlsAccountWallDivs.forEach((el, i) => {
          if (i > 1) {
            el.remove();
          }
        });
      }

      if (mlsAccountWallAds) {
        mlsAccountWallAds.forEach((el, i) => {
          el.remove();
        });
      }

      if (mlsAccountWallFooter) {
        mlsAccountWallFooter.forEach((el, i) => {
          el.remove();
        });
      }

      mlsAccountWallContent.forEach(function (element) {
        element.classList.remove("mls-account-wall-content");
      });
    }
  }
}
